import Home from "./Home"
import Concur from "./Concur"
import DataMap from "./DataMap"
import Sage from "./Sage"

export { Home, Concur, DataMap, Sage }

export default Home
